
import Button from '../../../components/base/Button';

export default function ClassesSection() {
  const handleBookClass = () => {
    const widget = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
    if (widget) {
      widget.click();
    }
  };

  const yogaClasses = [
    {
      name: "Morning Energy Yoga",
      description: "Start your morning with an uplifting yoga practice designed to gently awaken the body and mind. Recharge your body and fill yourself with energy for the entire day.",
      level: "All Levels",
      icons: 2
    },
    {
      name: "Power Yoga",
      description: "A dynamic, challenging class that builds strength and deepen yoga practice through powerful flows, longer holds, and arm balances while connecting breath with movement.",
      level: "Intermediate+",
      icons: 1
    },
    {
      name: "Energy Flow",
      description: "A dynamic Vinyasa-style class linking breath with movement as you flow from one posture to the next. Builds strength, flexibility, and balance while energizing the body and calming the mind.",
      level: "All Levels",
      icons: 2
    },
    {
      name: "Bikram Style Yoga",
      description: "A hot heated class inspired by the traditional Bikram-style yoga sequence, combining structured postures with upbeat music to create an energizing and immersive experience. Designed to build strength, flexibility, balance, and endurance while the heat supports deeper stretches, releases tension, and leaves you feeling refreshed and empowered.",
      level: "Intermediate+",
      icons: 2
    },
    {
      name: "Stretch & Relax Yoga",
      description: "This calming end-of-day class focuses on gentle stretches and slow yoga movements to release tension and improve flexibility through mindful breathing and longer-held poses.",
      level: "All Levels",
      icons: 2
    },
    {
      name: "Hatha Yoga",
      description: "A classic yoga class focused on posture, breath, and alignment. Movements are slower and held longer to build strength, improve flexibility, and balance.",
      level: "All Levels",
      icons: 2
    }
  ];

  const yogafitnessClasses = [
    {
      name: "Sculpt & Flow",
      description: "Combines yoga-style movement with light weights. Helps build strength, improve stability, and support overall conditioning in a warm room.",
      level: "All Levels",
      icons: 1
    },
    {
      name: "Fit & Flow",
      description: "A dynamic class that starts with a Vinyasa-style flow to warm the body and improve mobility, then transitions into strength training with yoga and functional exercises to build full-body strength and flexibility.",
      level: "Intermediate+",
      icons: 2
    },
    {
      name: "Yoga & Pilates",
      description: "A balanced class combining yoga flow and mat Pilates. Starts with Vinyasa-style movement to warm the body, then shifts to Pilates to build core strength, stability, and improve posture.",
      level: "All Levels",
      icons: 2
    },
    {
      name: "Mat Pilates",
      description: "Focus on strengthening the core (trunk) muscles while also engaging the arms and legs.You’ll build stability, improve posture, and develop better body control.",
      level: "All Levels",
      icons: 2
    }
  ];

  const fitnessClasses = [
    {
      name: "Pilates Fusion",
      description: "Focuses on core strength, posture, and control using Pilates inspired exercises. The warm environment supports mobility and deeper engagement.",
      level: "All Levels",
      icons: 2
    },{
      name: "Dance Fit",
      description: "A fun, music-based cardio workout using simple dance movements. Improves coordination, burns calories, and boosts energy.",
      level: "All Levels",
      icons: 1
    },{
      name: "Sculpt Core with Weights",
      description: "The focus is on strength, stability, and control. Weights combined with precise, controlled movements help tone muscles, build strength, and shape the entire body. \n",
      level: "All Levels",
      icons: 2
    },{
      name: "Core & Booty Burn",
      description: "Yoga, pilates, and strength training come together to focus on the core and glutes. Expect targeted movements that tone and strengthen your abs and butt.",
      level: "Intermediate+",
      icons: 2
    },{
      name: "Tone & Torch with Resistance Bend",
      description: "A full-body workout using a weighted body bar or free weights. The class blends strength training with bodyweight exercises to help tone, strengthen, and sculpt your body.",
      level: "All Levels",
      icons: 1
    },{
      name: "Cardio, Strength & Stretch",
      description: "A balanced class with a 20/20/20 format: starting with energizing cardio, followed by full-body strength training, and finishing with relaxing stretches to leave you refreshed and ready for the week.",
      level: "Intermediate+",
      icons: 2
    },{
      name: "Fusion Express",
      description: "A heated Pilates-based class using light weights, resistance bands, and props to build strength, stability, and flexibility. Focuses on core activation, posture, and a full-body workout guided by breath.",
      level: "All Levels",
      icons: 1
    }
  ];

  const ClassCard = ({ item, index, imgPrefix }) => (
      <div className="bg-[#F6F1EF] rounded-3xl shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden flex flex-col md:flex-row">
        <div className="w-full md:w-80 md:flex-shrink-0">
          <img
              src={`/img/${imgPrefix}${index + 1}.png`}
              alt={item.name}
              className="w-full h-48 md:h-full object-cover object-center"
          />
        </div>

        <div className="p-4 flex flex-col justify-between flex-1">
          <div>
            <h4 className="font-bold text-[#00889D] mb-2">{item.name}</h4>
            <p className="text-gray-600 text-sm mb-3">{item.description}</p>
          </div>

          <div className="flex items-center gap-2">
            {[...Array(item.icons)].map((_, i) => (
                <img
                    key={i}
                    src="/img/fire-icon.png"
                    alt="Level icon"
                    className="w-4 h-5"
                />
            ))}
            <span className="text-sm font-medium text-[#F6980E]">{item.level}</span>
          </div>
        </div>
      </div>
  );


  const sections = [
    { title: "Yoga", data: yogaClasses, img: "classes-yoga" },
    { title: "Yoga & Fitness", data: yogafitnessClasses, img: "classes-fitness-yoga" },
    { title: "Fitness", data: fitnessClasses, img: "classes-fitness" },
  ];

  return (
      <section className="py-10 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          {sections.map((sec, i) => (
              <div key={i} className="mb-12">
                <h3 className="text-3xl font-bold text-[#00889D] mb-8">{sec.title}</h3>

                <div className="grid xl:grid-cols-2 xl:gap-x-12 lg:gap-8 gap-4">
                  {sec.data.map((item, idx) => (
                      <ClassCard
                          key={idx}
                          item={item}
                          index={idx}
                          imgPrefix={sec.img}
                      />
                  ))}
                </div>
              </div>
          ))}
        </div>
      </section>
  );
}
